var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMndFilled = function SvgMndFilled(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2262_48214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.29044 24.1365L9.29044 14.4959C9.29044 14.0908 9.3015 13.6764 9.43611 13.2894C9.57072 12.9023 9.78711 12.5489 10.0705 12.253C10.354 11.957 10.6978 11.726 11.0785 11.5751C11.4593 11.4243 11.8681 11.3573 12.277 11.3787C14.3162 11.3787 15.1352 12.5918 15.1352 14.4637L15.1352 24.1044H19.0129L19.0129 14.4637C19.0129 12.7043 19.9764 11.3626 21.8952 11.3787C22.896 11.3787 23.5628 11.5882 24.0003 11.9674V7.75C23.322 7.6028 22.5813 7.53046 21.7908 7.53046C20.9441 7.52729 20.1052 7.69336 19.3235 8.01896C18.5418 8.34455 17.833 8.82305 17.2386 9.42647C16.2109 8.21334 14.5812 7.53046 12.1726 7.53046C9.0255 7.53046 5.64551 9.28989 5.64551 12.9855L5.64551 24.1365H9.29044Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2262_48214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMndFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mnd-filled.00f40822c9ef7156379fc0cc3575e645.svg";